import observer from 'saddlebag-observer';

import { TRACKING } from '../../../../constants';

export type HotelsCTAEvent = {
  impression_id: string;
  culture_settings: {
    country: string;
    locale: string;
    currency: string;
  };
  destination: {
    location_attribute: {
      location_attribute_encoding: string;
      location_id: string;
    };
  };
  checkin_date: {
    year: number;
    month: number;
    day: number;
  };
  checkout_date: {
    year: number;
    month: number;
    day: number;
  };
  number_of_adults: number;
  children_ages: number[];
  number_of_rooms: number;
  filters: {
    stars?: number;
  };
  cheapest_price: {
    amount: number | null;
    currency: string;
  };
  total_price: {
    amount: number | null;
    currency: string;
  };
};

// we will sort out the track, trackChokePoint, trackSmartMetric functions in the future
export function track<Message>(
  eventName: string,
  fullSchemaName: string,
  message: Message,
): void {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired: true,
  });
}

export const trackHotelsCTA = (trackingProps: HotelsCTAEvent) =>
  track(
    TRACKING.MESSAGES.EXPLORER_HOTELS_BTN_CLICKED,
    TRACKING.SCHEMAS.EXPLORER_HOTELS_BTN_CLICKED_SCHEMA,
    trackingProps,
  );
